// Central site content and configuration
// All content sourced from Dr. Anusha Mandava website copy

export const SITE = {
  name: "Dr. Anusha Mandava",
  role: "Radiation Oncologist",
  city: "Hyderabad",
  experience: "10 Years",
  phone: "+91 85229 47788",
  phoneRaw: "+918522947788",
  whatsapp: "918522947788",
  whatsappMessage: "Hello Dr. Anusha, I would like to book a consultation.",
  email: "anushadr23@gmail.com",
  address: {
    line1: "Consulting at leading oncology centres",
    line2: "Hyderabad, Telangana",
    country: "India",
    postal: "500001",
  },
  mapsEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d243646.8477229068!2d78.24323148710015!3d17.412280725064983!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99daeaebd2c7%3A0xae93b29a20d442f!2sHyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1700000000000",
  domain: "https://dr-anusha-oncology.preview.emergentagent.com",
  hours: "Mon – Sat, 10:00 AM – 6:00 PM",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Expertise", to: "/expertise" },
  { label: "Techniques", to: "/techniques" },
  { label: "Brachytherapy", to: "/brachytherapy" },
  { label: "Approach", to: "/approach" },
  { label: "FAQs", to: "/faqs" },
  { label: "Contact", to: "/contact" },
];

export const HERO = {
  eyebrow: "Radiation Oncology",
  heading: "Precision Cancer Care with Compassion and Clarity",
  subheading:
    "Dr. Anusha Mandava is a Radiation Oncologist in Hyderabad with 10 years of clinical experience, focused on evidence-based, patient-specific cancer treatment planning.",
  supporting:
    "Cancer treatment is not one-size-fits-all. Every patient needs a treatment plan built around their diagnosis, stage, overall health, and personal condition.",
};

export const TRUST_STRIP = [
  { value: "10+", label: "Years Clinical Experience" },
  { value: "Radiation", label: "Oncologist" },
  { value: "Hyderabad", label: "India" },
  { value: "Patient-Specific", label: "Cancer Care" },
];

export const INTRO = {
  heading: "Comprehensive Radiation Oncology Care",
  paragraphs: [
    "Cancer is a growing health challenge globally and in India. According to GLOBOCAN-2020 data, breast cancer was among the highest occurring cancers in females, followed by cervix, ovary, oral cavity, and colorectal cancers. In males, common cancers included lip and oral cavity, lung, stomach, colorectal, and esophagus cancers.",
    "With rising cancer incidence influenced by lifestyle, urbanization, increasing life expectancy, and screening patterns, timely diagnosis and comprehensive cancer care are becoming increasingly important.",
  ],
};

export const ABOUT = {
  short:
    "Dr. Anusha Mandava is a Radiation Oncologist in Hyderabad with 10 years of clinical experience, trained in reputed oncology institutions in Bangalore, with expertise in advanced radiation therapy and patient-specific cancer care.",
  long: [
    "Dr. Anusha Mandava is a passionate and empathetic Radiation Oncologist in Hyderabad with an overall clinical experience of 10 years. She completed her MBBS from Sri Devraj Urs Medical College, Kolar, under RGUHS affiliation.",
    "She pursued her postgraduate training from Kidwai Memorial Institute of Oncology, Bangalore, and Healthcare Global Enterprises Limited, Bangalore.",
    "Her approach to cancer care is built around multidisciplinary planning, latest evidence-based treatment, and customization of treatment options based on each patient's specific condition.",
  ],
  profile: [
    { label: "Role", value: "Radiation Oncologist" },
    { label: "Location", value: "Hyderabad" },
    { label: "Clinical Experience", value: "10 Years" },
    { label: "Special Focus", value: "Evidence-based, patient-specific cancer care" },
    { label: "MBBS", value: "Sri Devraj Urs Medical College, Kolar (RGUHS)" },
    { label: "Postgraduate", value: "Kidwai Memorial Institute of Oncology, Bangalore" },
    { label: "Fellowship", value: "Healthcare Global Enterprises Ltd., Bangalore" },
  ],
};

export const SPECIALITIES = [
  {
    title: "Breast Cancer",
    icon: "HeartPulse",
    body: "Radiation therapy planning for breast cancer care, designed around the patient's diagnosis, treatment stage, and overall clinical condition.",
  },
  {
    title: "Gynecological Cancers",
    icon: "Flower2",
    body: "Specialized radiation oncology care for cancers affecting the female reproductive system.",
  },
  {
    title: "Head and Neck Oncology",
    icon: "Brain",
    body: "Radiation treatment planning for head and neck cancers, where precision is important due to the complex anatomy involved.",
  },
  {
    title: "Lung Cancer",
    icon: "Wind",
    body: "Radiation oncology support for lung cancer care as part of a multidisciplinary treatment approach.",
  },
  {
    title: "Pediatric Oncology",
    icon: "Baby",
    body: "Cancer care support for children requiring radiation therapy, with treatment planning based on clinical need and patient safety.",
  },
  {
    title: "Neuro-Oncology",
    icon: "Sparkles",
    body: "Radiation therapy planning for brain and nervous system related cancers.",
  },
  {
    title: "Genito-Urinary Cancers",
    icon: "Droplets",
    body: "Radiation oncology care for cancers related to the urinary and reproductive systems.",
  },
  {
    title: "Gastrointestinal Cancers",
    icon: "Activity",
    body: "Radiation therapy planning for cancers affecting the digestive system.",
  },
];

export const TECHNIQUES = [
  {
    short: "IMRT",
    title: "Intensity Modulated Radiation Therapy",
    body: "IMRT helps deliver radiation with high precision while shaping the dose around the tumour area.",
  },
  {
    short: "VMAT",
    title: "Volumetric Modulated Arc Therapy",
    body: "VMAT allows advanced radiation delivery with efficient dose distribution across the target volume.",
  },
  {
    short: "IGRT",
    title: "Image Guided Radiation Therapy",
    body: "IGRT uses imaging support to improve accuracy during treatment delivery.",
  },
  {
    short: "SRS · SBRT",
    title: "Stereotactic Radiosurgery & Body Radiotherapy",
    body: "Highly focused radiation techniques used for selected cases where precision targeting is required.",
  },
  {
    short: "CyberKnife",
    title: "CyberKnife & Tomotherapy",
    body: "Advanced radiation platforms used for complex treatment planning and precise dose delivery.",
  },
  {
    short: "EBT",
    title: "Electron Beam Therapy",
    body: "A radiation therapy method used in selected cases depending on tumour type, depth, and location.",
  },
  {
    short: "TBI · TSET",
    title: "Total Body Irradiation & Total Skin Electron Therapy",
    body: "Specialized radiation techniques used in specific clinical conditions as part of planned oncology care.",
  },
];

export const BRACHY = {
  intro:
    "Dr. Anusha is adept at different forms of brachytherapy, including image-guided intracavitary and interstitial brachytherapy, intraluminal brachytherapy, and surface mould brachytherapy.",
  detail:
    "Brachytherapy is a focused form of radiation therapy used in selected cancers where radiation is delivered close to or within the tumour area. Treatment planning depends on the cancer type, location, stage, and the patient's overall clinical condition.",
  forms: [
    {
      title: "Image-Guided Intracavitary Brachytherapy",
      body: "Delivered within a body cavity using image guidance for precise dose placement.",
    },
    {
      title: "Interstitial Brachytherapy",
      body: "Radiation sources are placed directly inside or adjacent to the tumour tissue.",
    },
    {
      title: "Intraluminal Brachytherapy",
      body: "Used for cancers involving tubular structures, delivering radiation from inside the lumen.",
    },
    {
      title: "Surface Mould Brachytherapy",
      body: "A custom applicator is used to treat superficial lesions with focused radiation.",
    },
  ],
};

export const APPROACH_PILLARS = [
  {
    title: "Evidence-Based Planning",
    icon: "BookOpen",
    body: "Treatment decisions are guided by current clinical understanding and the patient's diagnosis.",
  },
  {
    title: "Multidisciplinary Care",
    icon: "Users",
    body: "Cancer care often involves coordination across different specialists to decide the most suitable treatment path.",
  },
  {
    title: "Compassionate Support",
    icon: "HandHeart",
    body: "Cancer treatment can be physically and emotionally demanding. The goal is to give patients clarity, confidence, and structured care throughout their treatment journey.",
  },
];

export const JOURNEY = [
  {
    step: "01",
    title: "Case Review",
    body: "Your diagnosis, reports, scans, and medical history are reviewed carefully.",
  },
  {
    step: "02",
    title: "Treatment Discussion",
    body: "The role of radiation therapy is explained based on your specific condition.",
  },
  {
    step: "03",
    title: "Personalized Planning",
    body: "A treatment plan is created depending on cancer type, stage, location, and overall health.",
  },
  {
    step: "04",
    title: "Therapy Execution",
    body: "Advanced radiation techniques are used where clinically appropriate.",
  },
  {
    step: "05",
    title: "Follow-Up Support",
    body: "Regular follow-up helps monitor progress, side effects, and recovery.",
  },
];

export const WHY = {
  heading: "Focused on Precision, Evidence, and Patient Comfort",
  intro:
    "Cancer care needs more than treatment. It needs clarity, coordination, and careful planning. Dr. Anusha's approach combines clinical experience, advanced radiation techniques, and a patient-specific treatment philosophy.",
  points: [
    "10 years of clinical experience in radiation oncology",
    "Expertise across breast, gynecological, head & neck, lung, pediatric, neuro, GU and GI cancers",
    "Skilled in advanced techniques: IMRT, VMAT, IGRT, SRS, SBRT, CyberKnife, Tomotherapy, brachytherapy",
    "Focus on evidence-based and individualized treatment planning",
  ],
};

export const FAQS = [
  {
    q: "What does a Radiation Oncologist do?",
    a: "A Radiation Oncologist specializes in using radiation therapy as part of cancer treatment. The treatment plan depends on cancer type, stage, tumour location, and the patient's overall condition.",
  },
  {
    q: "Does every cancer patient need radiation therapy?",
    a: "No. Radiation therapy is recommended only when clinically appropriate. Cancer care is multidisciplinary, and the treatment plan may include surgery, chemotherapy, radiation therapy, targeted therapy, immunotherapy, or a combination depending on the case.",
  },
  {
    q: "What cancers does Dr. Anusha treat?",
    a: "Her areas of expertise include breast cancer, gynecological cancers, head and neck oncology, lung cancer, pediatric oncology, neuro-oncology, genito-urinary cancers, and gastrointestinal cancers.",
  },
  {
    q: "What advanced radiation techniques is she skilled in?",
    a: "She is skilled in IMRT, VMAT, IGRT, SRS, SBRT, CyberKnife, Tomotherapy, Electron Beam Therapy, Total Body Irradiation, Total Skin Electron Therapy, and multiple forms of brachytherapy.",
  },
  {
    q: "How is the treatment plan decided?",
    a: "Treatment is planned based on the patient's diagnosis, stage of cancer, reports, scans, overall health, and multidisciplinary recommendations.",
  },
];

export const FINAL_CTA = {
  heading: "Take the First Step Towards Clearer Cancer Care",
  paragraph:
    "Get expert radiation oncology guidance with a treatment plan built around your specific condition.",
};

export const IMAGES = {
  heroDoctor: "/WhatsApp Image 2026-07-18 at 11.49.31 PM.jpeg",
  aboutDoctor: "/WhatsApp Image 2026-07-18 at 11.49.31 PM.jpeg",
  facility: "https://images.pexels.com/photos/247786/pexels-photo-247786.jpeg",
  patientCare: "/xray.jpeg",
  radiationTech: "/Edge 003 Hypersight 16_9_transparent.webp",
};
